// extracted by mini-css-extract-plugin
export var createdDate = "_md-1";
export var divider = "_md-2";
export var headerDivider = "_md-3";
export var messagesCard = "_md-0";
export var messagesContainer = "_md-7";
export var messagesContainerWrapper = "_md-4";
export var pointerCapturingButtonBoxes = "_md-a";
export var showLeftPanelButton = "_md-9";
export var showMoreButton = "_md-c";
export var showMoreButtonContainer = "_md-b";
export var summaryTitle = "_md-6";
export var systemMessageCardWrapper = "_md-d";
export var topButtons = "_md-8";
export var withPadding = "_md-5";